import { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Header.css';
import '../styles.css';

function Header() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="custom-navbar">
      <Navbar
        expand="lg"
        bg="light"
        variant="light"
        fixed="top"
        expanded={expanded}
        className="compact-navbar"
      >
        <Container fluid className="compact-container">
          {/* 🔹 Botón hamburguesa pequeño a la izquierda */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : 'expanded')}
            className="small-toggle"
          />

          {/* 🔹 Nombre */}
          <Navbar.Brand className="brand-title">
            Ginecólogo Daniel Sánchez Sarabia
          </Navbar.Brand>

          {/* 🔹 Menú colapsable */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-start">
            <Nav>
              <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Inicio</Nav.Link>
              <Nav.Link as={Link} to="/servicios" onClick={() => setExpanded(false)}>Servicios</Nav.Link>
              <Nav.Link as={Link} to="/sobremi" onClick={() => setExpanded(false)}>Sobre mí</Nav.Link>
              <Nav.Link as={Link} to="/contacto" onClick={() => setExpanded(false)}>Contacto</Nav.Link>
              <Nav.Link
                as="a"
                href="https://www.doctoralia.com.mx/daniel-sanchez-sarabia/ginecologo/oaxaca-de-juarez#profile-reviews"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setExpanded(false)}
              >
                Opiniones
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
